import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';

bus.on(constants.EVENTS.COMMING_SOON.ACTION_REQUIRED, (data) => {
  bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
    title: 'Bientot disponible',
    body: "Cette action n'est pas encore disponible dans votre région"
  });
});
